import { transport } from 'config/transport';

export function callApiExportCongDoanVungAnnually(academicYear, pdf = false) {
    return transport.get(`/trunguong/congdoanvung/report/exportReportAnnually`, { params: { academicYear, pdf }, responseType: 'blob' });
}
